import { Component, Input } from '@angular/core';

type Mode = 'determinate' | 'indeterminate';

@Component({
    selector: 'usimweb-progress-spinner',
    template: `
    <mat-progress-spinner [value]="value" [diameter]="diameter" [mode]="mode"></mat-progress-spinner>
  `,
    standalone: false
})
export class ProgressSpinnerComponent {
  @Input() value: number = 0;
  @Input() mode: Mode = 'indeterminate';
  @Input() diameter: number = 40;
}
